module.exports = __webpack_public_path__ + "static/media/babel-icon.3f3119f1.png";